var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.34 13.54c-1.15 0-2.08-.96-2.08-2.15 0-.41.34-.75.75-.75s.75.34.75.75c0 .36.26.65.58.65h1.5c.23 0 .41-.21.41-.47 0-.35-.06-.37-.29-.45l-2.41-.84c-.87-.3-1.3-.91-1.3-1.86 0-1.08.86-1.97 1.91-1.97h1.5c1.15 0 2.08.96 2.08 2.15 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.36-.26-.65-.58-.65h-1.5c-.23 0-.41.21-.41.47 0 .35.06.37.29.45l2.41.84c.87.31 1.29.92 1.29 1.86.01 1.09-.85 1.97-1.9 1.97h-1.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 13.59v-.74c0-.41.34-.75.75-.75s.75.34.75.75v.74a.749.749 0 1 1-1.5 0zM9.25 7.19v-.78c0-.41.34-.75.75-.75s.75.34.75.75v.78c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.98c0-4.82 3.92-8.74 8.74-8.74s8.74 3.92 8.74 8.74-3.93 8.74-8.74 8.74c-4.82 0-8.74-3.92-8.74-8.74zm1.5.01c0 3.99 3.25 7.23 7.24 7.23s7.24-3.25 7.24-7.24-3.25-7.23-7.24-7.23S2.75 6 2.75 9.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.359 20.3a.753.753 0 1 1 1.23-.87 4.197 4.197 0 0 0 7.63-2.42c0-1.35-.66-2.63-1.76-3.42a.751.751 0 1 1 .88-1.22 5.72 5.72 0 0 1 2.38 4.64 5.7 5.7 0 0 1-10.36 3.29z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCoin);
export default __webpack_public_path__ + "static/media/vuesax-outline-coin.6c640f8a21c531a96075b69d99601908.svg";
export { ForwardRef as ReactComponent };